import { wizardActionTypes as ActionTypes } from '../constants';
export function init(width, height) {
    return {
        type: ActionTypes.INIT_FABRIC,
        width, 
        height
    }
}

export function updateFabric(width, height) {
    return {
        type: ActionTypes.UPDATE_FABRIC,
        width, 
        height
    }
}
export function enableTool(toolType,color, toolEnabled) {
    return {
        type: ActionTypes.ENABLE_TOOL,
        toolType,
        color,
        toolEnabled
    }
}
export function selectTool(toolType) {
    return {
        type: ActionTypes.SELECT_TOOL,
        toolType
    }
}
export function resetZoom() {
    return {
        type: ActionTypes.RESET_ZOOM
    }
}
export function saveDrawing(data) {
    return {
        type: ActionTypes.SAVE_DRAWING,
        data
    }
}
export function exportDrawing(data) {
    return {
        type: ActionTypes.EXPORT_DRAWING,
        data
    }
}

export function setPageDetails(data) {
    return {
        type: ActionTypes.SET_PAGE_DETAILS,
        data
    }
}

export function setPageData(data){
    return {
        type: ActionTypes.SET_PAGE_DATA,
        data
    }
}
export function setDrawingData(data){
    return {
        type: ActionTypes.SET_DRAWING_DATA,
        data
    }
}
export function uploadExportDrawing(data, doc, categoriesWise){
    return {
        type: ActionTypes.UPLOAD_DRAWING,
        data,
        doc,
        categoriesWise,
    }
}
export function savePageOnReview(data){
    return {
        type: ActionTypes.REVIEW_PAGE,
        data
    }
}

export function getPages(data){
    return {
        type: ActionTypes.GET_PAGES,
        data
    }
}
export function previewDrawing(data) {
    return {
        type: ActionTypes.PREVIEW_DRAWING,
        data
    }
}

export function createNewPage(data){
    //need construct template
    /*TODO: (Satya) remove all this from action, pass newPage from component itself or do other side works in saga */
    return {
        type: ActionTypes.CREATE_NEW_PAGE,
        data
    }
}


export function handleDropAction(data){
    return {
        type: ActionTypes.HANDLE_DROP,
        data
    }
}

export function getProjectData(data){
    return {
        type: ActionTypes.GET_PROJECT,
        data
    }
}

export function getPlanOverViewData(data){
    return {
        type: ActionTypes.GET_PLAN_OVERVIEW,
        data
    }
}

export function setPageNotes(data){
    return {
        type: ActionTypes.SET_PAGE_NOTES,
        data
    }
}

export function setProjectError(data){
    return {
        type: ActionTypes.SET_PROJECT_FAILURE,
        data
    }
}

export function setRoomName(data){
    return {
        type: ActionTypes.SET_ROOM_NAME,
        data
    }
}

export function createPageCopy(data){
    return {
        type: ActionTypes.CREATE_PAGE_COPY,
        data
    }
}

export function removePage(data){
    return {
        type: ActionTypes.REMOVE_PAGE,
        data
    }
}

export function uploadImage(data){
    return {
        type: ActionTypes.UPLOAD_IMAGE,
        data
    }
}

export function removeImage(data){
    return {
        type: ActionTypes.REMOVE_IMAGE,
        data
    }
}

export function getImagesBasedOnTag(tag){
    return {
        type: ActionTypes.GET_TAG_IMAGES,
        tag
    }
}
export function imageData(data){
    return {
        type: ActionTypes.IMAGE_DATA,
        data
    }
}

export function uploadDqcData(data){
    return {
        type: ActionTypes.UPLOAD_DQC_DATA,
        data
    }
}

export function inputDqcData(data){
    return {
        type: ActionTypes.DQC_DETAILS,
        data
    }
}

export function updateDqcData(data){
    return {
        type:ActionTypes.UPDATE_DQC_DATA,
        data
    }
}

export function openGallery(data){
    return {
        type:ActionTypes.OPEN_GALLERY,
        data
    }
}
export function setRoomImages(data){
    return {
        type:ActionTypes.SET_ROOM_IMAGES,
        data
    }
}
export function textSelected(data){
    return {
        type: ActionTypes.TEXT_SELECTED,
        data
    }
}
export function selectedObject(data){
    return {
        type: ActionTypes.SELECTED_OBJECT,
        data
    }
}
export function copySelectedDrawing(){
    return {
        type: ActionTypes.COPY_SELECTED_DRAWING
    }
}
export function pasteSelectedDrawing(){
    return {
        type: ActionTypes.PASTE_SELECTED_DRAWING
    }
}

export function orderProfileType(data){
    return {
        type:ActionTypes.ORDER_PROFILE_TYPE,
        data
    }
}

export function grouping(data){
    return {
        type: ActionTypes.GROUPING,
        data:data
    }
}

export function enableLayering(flag){
    return {
        type: ActionTypes.ENABLE_LAYERING,
        data:flag
    }
}

export function getRosterToken(data){
    return {
        type: ActionTypes.GET_ROSTER_TOKEN,
        data
    }
}

export function saveUpdatedPageDetails(data, updateRequired) {
    return {
        type: ActionTypes.SAVE_UPDATED_PAGE_DETAILS,
        data,
        updateRequired
    }
}

export function expandCollapseSideMenu(data) {    
    return {
        type: ActionTypes.EXPAND_COLLAPSE_SIDEBAR_MENU,
        data,
    }
}

export function saveMetaDataUpdate(data) {    
    return {
        type: ActionTypes.REQUIRED_META_DATA_UPDATE,
        data,
    }
}

export function enableCropOption(data) {    
    return {
        type: ActionTypes.CROP_IMAGE,
        data
    }
}

export function saveCropSelectionDetails (data) {
    return {
        type: ActionTypes.SAVE_CROP_IMAGE_DETAILS,
        data,
    }
}

export function showTableModal(data) {    
    return {
        type: ActionTypes.SHOW_CREATION_TABLE_MODAL,
        data,
    }
}


export function croppingSelectedImage() {    
    return {
        type: ActionTypes.CROP_SELECTED_IMAGE,
    }
}

export function enablePaintFormatting(data) {        
    return {
        type: ActionTypes.PAINT_FORMATTING_ENABLE,
        data
    }
}

export function uploadingImages() {    
    return {
        type: ActionTypes.UPLOADING_IMAGES,
    }
}